import { render, staticRenderFns } from "./productPlatformCategory.vue?vue&type=template&id=16d79cbe&scoped=true&"
import script from "./productPlatformCategory.vue?vue&type=script&lang=js&"
export * from "./productPlatformCategory.vue?vue&type=script&lang=js&"
import style0 from "./productPlatformCategory.vue?vue&type=style&index=0&id=16d79cbe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d79cbe",
  null
  
)

export default component.exports